import React, { useMemo, useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import RunPanel from "./RunPanel";
import RunPicker from "./RunPicker";
import { zb, fileUrl } from "./api";
import styles from "./ZohoBilling.module.css";

export default function ReconTab({ runs, activeRunId, onChanged }) {
  const mine = useMemo(() => runs.filter((r) => r.kind === "recon"), [runs]);
  const [selected, setSelected] = useState(null);
  const [starting, setStarting] = useState(false);
  const current = selected || (mine[0] && mine[0].id);

  const start = async () => {
    setStarting(true);
    try {
      const data = await zb("/recon", { method: "POST" });
      setSelected(data.runId);
      onChanged();
    } catch (err) {
      toast.error(err.message);
    } finally {
      setStarting(false);
    }
  };

  return (
    <>
      <div className={styles.card}>
        <div className={styles.runHead}>
          <div>
            <div className={styles.cardTitle}>Invoice reconciliation scan</div>
            <div className={styles.muted}>
              Read-only. Lists open sales invoices (balance &gt; 0) and paid invoices whose payment isn’t tied to a real bank
              transaction, as a two-sheet Excel file.
            </div>
          </div>
          <Button className={styles.primaryBtn} variant="contained" disabled={starting || Boolean(activeRunId)} onClick={start}>
            {starting ? <CircularProgress size={16} color="inherit" /> : "Run scan"}
          </Button>
        </div>
      </div>
      <RunPicker runs={mine} current={current} onSelect={setSelected} activeRunId={activeRunId} />
      {current && (
        <RunPanel key={current} runId={current} onChanged={onChanged}>
          {(run) =>
            run.result ? (
              <div className={styles.okBox}>
                <strong>{run.result.openInvoices}</strong> open invoice(s) · <strong>{run.result.paidUnmatched}</strong> paid
                with an unmatched payment ·{" "}
                <a className={styles.linkBtn} href={fileUrl(run.id, run.result.file)}>
                  Download {run.result.file}
                </a>
              </div>
            ) : null
          }
        </RunPanel>
      )}
    </>
  );
}
